<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import Swal from "sweetalert2";
import errorHandling from "../../../mixins/errorHandling";

/**
 * Product Detail Component
 */
export default {
  mixins: [errorHandling],
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      paymnentTypeId: "1",

      title: "Withdrawal",
      items: [
        {
          text: "Agent",
        },
        {
          text: "Withdrawal",
          active: true,
        },
      ],
      customer: "",
      customerImage: "",
      savingsData: [],
      submitted: false,
      name: "",
      loanName: "",
      phone: "",
      amount: "",
      accountNumber: "",
      loading: false,
      paying: false,
    };
  },
  validations: {
    name: { required },
    loanName: { required },
    phone: { required },
    amount: { required },
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    formSubmit(e) {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
    },
    /**
     * Selected image shows
     */
    imageShow(event) {
      const image = event.target.src;
      const expandImg = document.getElementById("expandedImg");
      expandImg.src = image;
    },
    async getCustomer() {
      this.loading = true;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/agent/get-one-customer-by-id/${this.$route.params.id}`
        );
        if (response.status === 200 || response.status === 201) {
          this.customer = response.data.data;
          this.name = response.data.data.displayName;
          this.phone = response.data.data.mobileNo;
          this.loading = false;
        } else {
          this.loading = false;
          this.throwError();
        }
      } catch (error) {
        this.handleError(error.response.data.message);
        this.loading = false;
      }
    },
    async getCustomerSavings() {
      this.loading = true;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/agent/get-customer-savings/${this.$route.params.savingsID}`
        );
        if (response.status === 200 || response.status === 201) {
          this.savingsData = response.data.data;
          this.loanName = response.data.data.savingsProductName;
          this.accountNumber = response.data.data.accountNo;
          this.loading = false;
        } else {
          this.loading = false;
          this.throwError();
        }
      } catch (error) {
        this.handleError(error.response.data.message);
        this.loading = false;
      }
    },

    async getCustomerImage() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/agent/get-customer-image/${this.$route.params.id}`
        );
        if (response.status === 200 || response.status === 201) {
          this.customerImage = response.data.data;
        } else {
          this.throwError();
        }
      } catch (error) {
        this.handleError("Error fetching customer image");
      }
    },
    async verifyPayment() {
      try {
        const confirmationResult = await Swal.fire({
          title: "Are you sure?",
          text: "Please confirm this action",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Yes, confirm!",
        });

        if (confirmationResult.isConfirmed) {
          this.paying = true;
          const url = `${
            process.env.VUE_APP_BASE_URL
          }/agent-transaction/make-withdrawal-savings/${
            this.$route.params.savingsID
          }/${localStorage.getItem("id")}`;
          const response = await axios.post(url, {
            transactionAmount: this.amount,
            paymentTypeId: this.paymnentTypeId,
            customerPhoneNumber: this.phone,
            customerName: this.name,
            accountNumber: this.accountNumber,
            transactionPaymentType: "Individual",
          });

          if (response.status === 200 || response.status === 201) {
            this.paying = false;
            await Swal.fire(
              "Success!",
              "Withdrawal Made, Verification Sent",
              "success"
            );

            // Redirect after Swal is closed
            window.location = "/agent/transactions";
          } else {
            this.paying = false;
            Swal.fire("Error!", "An error occurred!", "error");
          }
        }
      } catch (error) {
        this.paying = false;
        Swal.fire("Error!", error.response.data.defaultUserMessage, "error");
      }
    },
  },
  async mounted() {
    this.getCustomer();
    this.getCustomerSavings();
    this.getCustomerImage();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="loading">
      <b-spinner class="m-2 m-auto" variant="primary" role="status"></b-spinner>
    </div>
    <div class="row" v-else>
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-2">
                <div class="product-detail">
                  <div class="row">
                    <div class="col-md-12 col-9">
                      <div class="tab-content" id="v-pills-tabContent">
                        <div
                          class="tab-pane fade show active"
                          id="product-1"
                          role="tabpanel"
                        >
                          <div class="product-img">
                            <img
                              id="expandedImg"
                              :src="customerImage"
                              alt
                              class="img-fluid mx-auto d-block"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end product img -->
              </div>
              <div class="col-xl-10">
                <div class="mt-4 mt-xl-3">
                  <a href="#" class="text-primary font-size-20">Withdrawal</a>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="card">
                        <div class="card-body">
                          <div class="media">
                            <div class="media-body overflow-hidden">
                              <p class="text-truncate font-size-14 mb-2">
                                Customer Name
                              </p>
                              <h4 class="mb-0">{{ customer.displayName }}</h4>
                            </div>
                            <div class="text-primary">
                              <i class="ri-user-3-line font-size-24"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="card">
                        <div class="card-body">
                          <div class="media">
                            <div class="media-body overflow-hidden">
                              <p class="text-truncate font-size-14 mb-2">
                                Phone Number
                              </p>
                              <h4 class="mb-0">{{ customer.mobileNo }}</h4>
                            </div>
                            <div class="text-primary">
                              <i class="ri-phone-line font-size-24"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card">
                        <div class="card-body">
                          <div class="media">
                            <div class="media-body overflow-hidden">
                              <p class="text-truncate font-size-14 mb-2">
                                Account Number
                              </p>
                              <h4 class="mb-0">{{ customer.accountNo }}</h4>
                            </div>
                            <div class="text-primary">
                              <i class="ri-hashtag font-size-24"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="col-lg-12"></div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="card">
                        <div class="card-body">
                          <div class="media">
                            <div class="media-body overflow-hidden">
                              <p class="text-truncate font-size-14 mb-2">
                                Savings Account / Account Balance
                              </p>
                              <h4 class="mb-0">
                                GHS {{ savingsData.summary.availableBalance }}
                              </h4>
                            </div>
                            <div class="text-primary">
                              <i class="ri-user-3-line font-size-24"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Withdrawal Verification</h4>
                      <p class="card-title-desc">
                        Enter the customers number below to send a verification
                        SMS to verify payment
                      </p>
                      <form
                        class="needs-validation"
                        @submit.prevent="formSubmit"
                      >
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="validationCustom01">Name</label>
                              <input
                                id="validationCustom01"
                                v-model="name"
                                disabled
                                type="text"
                                class="form-control"
                                placeholder="Name"
                                value="Mark"
                                :class="{
                                  'is-invalid': submitted && $v.name.$error,
                                }"
                              />
                              <div
                                v-if="submitted && $v.name.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.name.required"
                                  >This value is required.</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="validationCustom02"
                                >Savings Name</label
                              >
                              <input
                                id="validationCustom02"
                                v-model="loanName"
                                disabled
                                type="text"
                                class="form-control"
                                placeholder="Loan name"
                                value="Name"
                                :class="{
                                  'is-invalid': submitted && $v.loanName.$error,
                                }"
                              />
                              <div
                                v-if="submitted && $v.loanName.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.loanName.required"
                                  >This value is required.</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label for="validationCustom03"
                                >Phone Number - (A verification SMS will be
                                sent)</label
                              >
                              <input
                                id="validationCustom03"
                                v-model="phone"
                                type="text"
                                disabled
                                class="form-control"
                                placeholder="055*******"
                                :class="{
                                  'is-invalid': submitted && $v.phone.$error,
                                }"
                              />
                              <div
                                v-if="submitted && $v.phone.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.phone.required"
                                  >This value is required.</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label for="validationCustom04"
                                >Account Number</label
                              >
                              <input
                                id="validationCustom04"
                                disabled
                                v-model="accountNumber"
                                type="text"
                                class="form-control"
                                placeholder="Account Number"
                                :class="{
                                  'is-invalid':
                                    submitted && $v.accountNumber.$error,
                                }"
                              />
                              <div
                                v-if="submitted && $v.accountNumber.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.accountNumber.required"
                                  >This value is required.</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label for="validationCustom04">Amount</label>
                              <input
                                id="validationCustom04"
                                v-model="amount"
                                type="text"
                                class="form-control"
                                placeholder="0.00"
                                :class="{
                                  'is-invalid': submitted && $v.amount.$error,
                                }"
                              />
                              <div
                                v-if="submitted && $v.amount.$error"
                                class="invalid-feedback"
                              >
                                <span v-if="!$v.amount.required"
                                  >This value is required.</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row"></div>
                        <b-button
                          variant="primary"
                          size="lg"
                          @click.prevent="verifyPayment"
                        >
                          <i class="ri-check-double-line align-middle mr-2"></i>
                          Verify Payment
                          <span
                            class="spinner-border mb-1 ml-2 spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                            v-if="paying"
                          ></span>
                        </b-button>
                      </form>
                    </div>
                  </div>
                  <!-- end card -->

                  <hr class="my-4" />
                </div>
              </div>
            </div>
            <!-- end row -->
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
.custom-radio-group {
  width: 100%; /* Adjust the width value as per your requirement */
}
</style>
